import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'

@Component({
  selector: 'dmmp-toggle-menu',
  templateUrl: './toggle-menu.component.html'
})
export class ToggleMenuComponent implements OnInit {

  @Output() page = new EventEmitter()
  @Output() clickAction = new EventEmitter()

  constructor() { }

  ngOnInit(): void {
  }

}
